import { createContext, useReducer } from "react";

export const AdminsContext = createContext();

export const adminReducer = (state, action) => {
  switch (action.type) {
    case "SET_PHONE_NUMBERS":
      return {
        admins: action.payload,
      };
    case "CREATE_PHONE_NUMBER":
      return {
        admins: [action.payload, ...state.admins],
      };
    case "DELETE_PHONE_NUMBER":
      return {
        admins: state.admins.filter((p) => p._id !== action.payload._id),
      };
    case "DELETE_ADMIN":
      return {
        admins: state.admins.filter((p) => p._id !== action.payload._id),
      };
    default:
      return state;
  }
};

export const AdminContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(adminReducer, {
    admins: null,
  });

  return (
    <AdminsContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AdminsContext.Provider>
  );
};
